import { useQuery } from 'react-query';
import { usePostCommunicationContext } from '../PostCommunicationProvider';
import { PostCommunicationContent } from '../types/postCommunicationContent';
import { queryKey } from 'constants/queryKey';
import CommentsApi from 'app/modules/comments/api';
import { useEffect } from 'react';

const useHasPinnedComments = () => {
  const { postId, changeActiveContent, activeContent, allowedActiveContent } =
    usePostCommunicationContext();

  const comments = useQuery(
    queryKey.postCommentsPinnedThread({
      postId: postId,
      thread: PostCommunicationContent.PINNED,
    }),
    async () => CommentsApi.comments(postId, { pinned: 1 }),
  );

  const firstAllowed = allowedActiveContent[0];
  const commentsLength = comments.data?.data?.length || 0;

  useEffect(() => {
    if (comments.data?.data?.length) {
      return;
    }

    if (activeContent === PostCommunicationContent.PINNED && firstAllowed) {
      changeActiveContent(firstAllowed);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [commentsLength, firstAllowed, activeContent]);

  return {
    hasPinned: !!comments.data?.data?.length,
  };
};

export default useHasPinnedComments;
